import { render, staticRenderFns } from "./px-corner-ribbon.vue?vue&type=template&id=33675262&scoped=true&"
import script from "./px-corner-ribbon.vue?vue&type=script&lang=ts&"
export * from "./px-corner-ribbon.vue?vue&type=script&lang=ts&"
import style0 from "./px-corner-ribbon.vue?vue&type=style&index=0&id=33675262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33675262",
  null
  
)

export default component.exports